module.exports = __webpack_public_path__ + "img/Jianto.c384f953.svg";